import { Tag } from "../../Tag/Tag";
import {
  ElectricBoltOutlined,
  ElectricalServicesOutlined,
} from "../../../materialUi/materialUi";
import { colorTagProps } from "./colorTagProps";

export type EnergyRecommendation =
  | "ELECTRIC"
  | "PLUGIN_HYBRID"
  | "NOT_ELIGIBLE"
  | "INSUFFICIENT_DATA";

const recommendationProps: Record<
  EnergyRecommendation,
  {
    color: (typeof colorTagProps)[keyof typeof colorTagProps];
    iconLeft?: JSX.Element;
  }
> = {
  ELECTRIC: {
    color: colorTagProps.success,
    iconLeft: <ElectricBoltOutlined />,
  },
  PLUGIN_HYBRID: {
    color: colorTagProps.informative,
    iconLeft: <ElectricalServicesOutlined />,
  },
  NOT_ELIGIBLE: { color: colorTagProps.neutral },
  INSUFFICIENT_DATA: { color: colorTagProps.neutral },
};

export const TableTagEnergyRecommendation = (props: {
  energyRecommendation: EnergyRecommendation;
  text: string;
}) => {
  const { color, iconLeft } = recommendationProps[props.energyRecommendation];
  return (
    <Tag
      text={props.text}
      backgroundColor={color.backgroundColor}
      textColor={color.textColor}
      iconColor={color.iconColor}
      iconLeft={iconLeft}
    />
  );
};
